import { Inject, Input, Component, DOCUMENT } from '@angular/core';
import { TemplateControlService } from './controls/template-control.service';

import { TemplateControlType, TemplateControlAction, ControlActionType } from 'src/app/modules/management/store/communication-center';
import { UserPreferencesFacade } from '@app/core/stores/user-preferences';

@Component({
    selector: 'topo-template-builder',
    templateUrl: './template-builder.component.html',
    styleUrls: ['./template-builder.component.scss'],
    standalone: false
})
export class TemplateBuilderComponent {
  @Input() set mapImage(value: string) {
    setTimeout(() => {
      this.setMapImage(value);
    });
  }
  @Input() set selectedAssets(value: string) {
    setTimeout(() => {
      this.setAssets(value);
    });
  }
  @Input() isFullHeight: boolean = false;
  @Input() showEditAction: boolean = true;
  @Input() showDeleteAction: boolean = true;
  @Input() showCopyAction: boolean = true;
  @Input() set enableDrag(value: boolean) {
    this._enableDrag = value;
    this.templateControlService.enableDrag = value;
  }
  get enableDrag(): boolean {
    return this._enableDrag;
  }
  _enableDrag: boolean = true;
  @Input() enableMentions: boolean;
  @Input() mentionSearch: (args: any, renderList: any) => void;
  @Input() showLetsBuild: boolean = true;
  @Input() showSlackHeader: boolean = false;
  @Input() showMicrosoftTeamsHeader: boolean = false;
  @Input() headerDatasetType: string = '';
  @Input() headerDatasetName: string = '';
  @Input() slackHeaderName: string = '';

  constructor(@Inject(DOCUMENT) private document: any, public templateControlService: TemplateControlService, protected userPref: UserPreferencesFacade) {}

  designSurfaceScroll(): void {
    this.templateControlService.hideSettingsControlIfNotEdit();
  }

  dragenter(event): any {
    if (this.enableDrag) {
      event.preventDefault();
      return false;
    }
  }

  dragover(event): any {
    if (this.enableDrag) {
      event.preventDefault();
      return false;
    }
  }

  drop(event): any {
    if (!this.enableDrag) {
      return;
    }

    event.preventDefault();

    const sourceElement: HTMLElement = event.srcElement;
    const actionData = event.dataTransfer.getData('text/plain');
    const action: TemplateControlAction = JSON.parse(actionData);

    if (action.actionType === ControlActionType.Add) {
      if (
        sourceElement.id === 'design-surface' ||
        sourceElement.classList.contains('lets-build') ||
        sourceElement.parentElement.classList.contains('lets-build')
      ) {
        const row = this.templateControlService.addControlToRoot(TemplateControlType.TableRow);
        const control = this.templateControlService.addChildControlToParentControl(row, action.controlType);
      }
    }

    return false;
  }

  setAssets(value: string): void {
    if (value) {
      const elementCollection: any = document.querySelectorAll('.topo-selected-assets');
      elementCollection.forEach(div => (div.innerHTML = value));
    }
  }

  setMapImage(value: string): void {
    if (value) {
      const elementCollection: any = document.querySelectorAll('.map-image');
      elementCollection.forEach(image => (image.src = value));
    }
  }
}
